import { translateEntireObj } from '@icp/i18n';
import { restApi } from '@icp/settings';

export function getDomainOptions() {
  return restApi.getStatic(`${window.ICP_PUBLIC_PATH}/domain-options.json`).then((res) => {
    translateEntireObj(res);
    return res;
  });
}
